import { signal } from '@preact/signals-react';

import { LoyaltyApi } from '../api';

class LoyaltyStore {
  balance = signal<number>(0);

  fetchBalance = async (restaurantId: number) => {
    try {
      this.balance.value = await LoyaltyApi.getBonuses(restaurantId);
    } catch (e) {
      this.balance.value = 0;
    }
  };
}

export const loyaltyStore = new LoyaltyStore();
